import './notifications.scss';
import { Dispatch, SetStateAction } from 'react';
import { useHistory } from 'react-router-dom';
import api from 'api';

function Notifications({
    notifications,
    open,
    setOpen,
    markAsSeen,
    deleteNotification
} : {
    notifications: any[],
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>,
    markAsSeen: (id: number) => void,
    deleteNotification: (id: number) => void
}) {
    const history = useHistory();

    const clickNotification = (id: number, url: string, e: any) => {
        e.currentTarget.classList.remove('unread');
        markAsSeen(id);
        setOpen(false);
        history.push(url);
    }

    const markAsSeenClick = (id: number, e: any) => {

    }

    const markAllAsSeen = () => {
        api.notification.markAllAsSeen();
        const els = Array.from(document.getElementsByClassName('notification'));
        els.map(x => {
            return x.classList.remove('unread');
        })
    }

    return (
        <div className={`notifications ${open ? 'open' : ''}`}>
            {notifications.length === 0 ? <i>No new notifications</i> : (
                <>
                    <button onClick={markAllAsSeen}>Read All</button>
                    {notifications.map((x: any, i: number) => (
                        <div className={`notification ${x.IsSeen ? `` : `unread`}`} key={i} onClick={e => clickNotification(x.Id, x.ClickUrl, e)}>
                            <i className="fal fa-user-circle"></i>
                            <i className="fal fa-trash delete" onClick={e => { e.stopPropagation(); deleteNotification(x.Id); }}></i>
                            {!x.IsSeen && <i className="fal fa-eye read" onClick={e => { e.stopPropagation(); markAsSeen(x.Id); }}></i>}
                            <p dangerouslySetInnerHTML={{__html: x.Message}}></p>
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}

export default Notifications;